export default __webpack_public_path__ + "static/media/check-account-hint.4e9044c0.svg";